module.exports = __webpack_public_path__ + "static/media/saving_investment.a08fd8cd.svg";